<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
import { buildMetaInfo } from './seo-meta'

export default {
  // 全站的 title / description / canonical / og / hreflang 都在这里统一生成，
  // 数据源是 src/seo.js。各页面组件不需要再各自声明 metaInfo。
  metaInfo() {
    // 价格方案从 i18n 取，SoftwareApplication 的 offers 要用
    const plans = this.$t('index.price.plans')
    return buildMetaInfo(this.$route.path, plans)
  }
}
</script>

<style lang="scss">
/**
 * 图片的 width/height 属性只用来给浏览器提供宽高比（避免加载时的布局跳动），
 * 不能让它决定实际高度。
 *
 * 只写了 width 的 CSS（比如 style="width: 1024px" 或某个 class）配上 height 属性时，
 * 高度会被属性值接管，图片就会被拉伸 —— /photoshop 和 /sketch 的首图就是这么变形的。
 * 加上 height: auto 之后，宽高比提示保留，实际高度仍由宽度按比例推导。
 *
 * 选择器只命中同时带两个属性的图片，即本次为防 CLS 补过尺寸的那些；
 * 只写 height（如导航栏 logo）的图片不受影响。
 */
img[width][height] {
  height: auto;
}
</style>
